import { Link } from 'react-router-dom';
import CategoryBadge from '@/components/base/CategoryBadge';
import type { Topic } from '@/mocks/topics';

interface TrendingRankingProps {
  topics: Topic[];
}

export default function TrendingRanking({ topics }: TrendingRankingProps) {
  const maxHeat = Math.max(...topics.map((t) => t.heat));

  return (
    <section aria-labelledby="ranking-title" className="w-full">
      <div className="flex items-end justify-between border-b-2 border-foreground-900 pb-3">
        <div>
          <p className="font-label text-xs uppercase tracking-[0.2em] text-primary-600">Trending</p>
          <h2 id="ranking-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
            热门议题榜单
          </h2>
        </div>
        <span className="hidden font-label text-xs text-foreground-500 sm:block">
          按近期讨论热度排序
        </span>
      </div>

      <ol className="mt-2 divide-y divide-background-300">
        {topics.map((topic, index) => (
          <li key={topic.slug}>
            <Link to={`/topics/${topic.slug}`} className="group flex items-center gap-5 py-4">
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                  index < 3
                    ? 'bg-primary-600 text-background-50'
                    : 'bg-background-200 text-foreground-700'
                }`}
              >
                {index + 1}
              </span>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="flex flex-wrap items-center gap-2">
                  <CategoryBadge category={topic.category} size="sm" />
                  <span className="font-label text-xs text-foreground-500">{topic.date}</span>
                </span>
                <span className="mt-1.5 truncate font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {topic.title}
                </span>
                <span className="mt-2 hidden h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-background-200 sm:block">
                  <span
                    className="block h-full rounded-full bg-accent-500"
                    style={{ width: `${Math.round((topic.heat / maxHeat) * 100)}%` }}
                  ></span>
                </span>
              </span>
              <span className="hidden shrink-0 items-center gap-1 font-label text-sm text-accent-700 sm:flex">
                <i className="ri-fire-line" aria-hidden="true"></i>
                {topic.heat.toLocaleString('zh-CN')}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}